import { createFileRoute } from '@tanstack/react-router'
import { PasswordResetConfirmPage } from 'features/auth'

export const Route = createFileRoute('/_unauthenticated/reset_confirm/')<{
  routeState: { id: string }
}>({
  component: PasswordResetConfirmPage,
})
